import withModalProps from 'web-interactives-dashboard-ui/hoc/withModalProps';
import { MODAL_TYPES } from 'web-interactives-dashboard-ui/constants/ModalConstants';
import VariantsModal from 'personalization-lib/components/variantsModal/VariantsModal';
import { jsx as _jsx } from "react/jsx-runtime";
const PersonalizationVariantsModal = ({
  personalizationStrategyId,
  onClose
}) => {
  return /*#__PURE__*/_jsx(VariantsModal, {
    strategyId: personalizationStrategyId,
    onClose: onClose
  });
};
export default withModalProps(PersonalizationVariantsModal, MODAL_TYPES.PERSONALIZATION_VARIANTS_MODAL);